export const beforeAfterItems = [
  {
    id: 1,
    title: "პროექტი 01",
    before: "/gallery/project-01-before.jpg",
    after: "/gallery/project-01-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-01-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-01-after/1200/800",
  },
  {
    id: 2,
    title: "პროექტი 02",
    before: "/gallery/project-01-after.jpg",
    after: "/gallery/project-01-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-02-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-02-after/1200/800",
  },
  {
    id: 3,
    title: "პროექტი 03",
    before: "/gallery/project-02-before.jpg",
    after: "/gallery/project-02-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-03-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-03-after/1200/800",
  },
  {
    id: 4,
    title: "პროექტი 04",
    before: "/gallery/project-02-after.jpg",
    after: "/gallery/project-02-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-04-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-04-after/1200/800",
  },
  {
    id: 5,
    title: "პროექტი 05",
    before: "/gallery/project-03-before.jpg",
    after: "/gallery/project-03-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-05-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-05-after/1200/800",
  },
  {
    id: 6,
    title: "პროექტი 06",
    before: "/gallery/project-03-after.jpg",
    after: "/gallery/project-03-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-06-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-06-after/1200/800",
  },
  {
    id: 7,
    title: "პროექტი 07",
    before: "/gallery/project-04-before.jpg",
    after: "/gallery/project-04-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-07-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-07-after/1200/800",
  },
  {
    id: 8,
    title: "პროექტი 08",
    before: "/gallery/project-04-after.jpg",
    after: "/gallery/project-04-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-08-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-08-after/1200/800",
  },
  {
    id: 9,
    title: "პროექტი 09",
    before: "/gallery/project-05-before.jpg",
    after: "/gallery/project-05-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-09-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-09-after/1200/800",
  },
  {
    id: 10,
    title: "პროექტი 10",
    before: "/gallery/project-05-after.jpg",
    after: "/gallery/project-05-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-10-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-10-after/1200/800",
  },
  {
    id: 11,
    title: "პროექტი 11",
    before: "/gallery/project-06-before.jpg",
    after: "/gallery/project-06-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-10-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-10-after/1200/800",
  },
  {
    id: 12,
    title: "პროექტი 12",
    before: "/gallery/project-06-after.jpg",
    after: "/gallery/project-06-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-10-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-10-after/1200/800",
  },
  {
    id: 13,
    title: "პროექტი 13",
    before: "/gallery/project-07-before.jpg",
    after: "/gallery/project-07-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-10-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-10-after/1200/800",
  },
  {
    id: 14,
    title: "პროექტი 14",
    before: "/gallery/project-07-after.jpg",
    after: "/gallery/project-07-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-10-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-10-after/1200/800",
  },
  {
    id: 15,
    title: "პროექტი 15",
    before: "/gallery/project-08-before.jpg",
    after: "/gallery/project-08-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-15-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-15-after/1200/800",
  },
  {
    id: 16,
    title: "პროექტი 16",
    before: "/gallery/project-08-after.jpg",
    after: "/gallery/project-08-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-16-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-16-after/1200/800",
  },
  {
    id: 17,
    title: "პროექტი 17",
    before: "/gallery/project-09-before.jpg",
    after: "/gallery/project-09-before.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-10-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-10-after/1200/800",
  },
  {
    id: 18,
    title: "პროექტი 18",
    before: "/gallery/project-09-after.jpg",
    after: "/gallery/project-09-after.jpg",
    fallbackBefore: "https://picsum.photos/seed/gd-10-before/1200/800",
    fallbackAfter: "https://picsum.photos/seed/gd-10-after/1200/800",
  },
];
